_ = require 'underscore'
makeErrorEnum = require 'lib/make-error-enum'
parseURL = require 'url-parse'
pluginValidators = require 'lib/util/plugin-validators'
PostMessageIO = require '@atlassian/trello-post-message-io'
Promise = require 'bluebird'
sandboxParams = require 'data/plugin-iframe-sandbox'
xtend = require 'xtend'

INITIALIZE_TIMEOUT = 20000 # gives us 20 seconds to load the index iframe for a Power-Up

IFrameIOError = makeErrorEnum 'IFrameIO', [
  'Invalid'
  'NotHandled'
  'Timeout'
]

host = null
getHost = ->
  if !host?
    id = 'iframe-io-host'
    host = document.createElement('div')
    host.id = id
    body = document.getElementsByTagName('body')[0]
    if !body
      throw Error('no body to host iframes')
    body.appendChild(host)
  host

module.exports = class IFrameIO
  @Error: IFrameIOError
  constructor: (@url, @handlers) ->

  _getIO: ->
    @_io ?= new Promise (resolve) =>
      if !pluginValidators.isValidUrlForIframe(@url)
        throw IFrameIOError.Invalid("Provided iframe source not valid: #{@url}")

      iframe = document.createElement('iframe')
      iframe.sandbox = sandboxParams
      iframe.src = @url
      # see: https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-permissions-in-cross-origin-iframes
      iframe.allow = 'microphone; camera'
      @_iframeEl = iframe

      getHost().appendChild(iframe)

      secret = PostMessageIO.randomId(64)

      io = new PostMessageIO
        local: window
        remote: iframe.contentWindow
        targetOrigin: parseURL(@url).set('pathname', '').href
        secret: secret
        handlers: xtend @handlers,
          'initialize': =>
            secret: secret
          'ready': =>
            resolve(io)

    .timeout(INITIALIZE_TIMEOUT)
    .catch Promise.TimeoutError, =>
      if (console?.error)
        console.error("Error, timeout while initializing index iframe for #{@url}. Timeout=#{ INITIALIZE_TIMEOUT }ms")
      throw IFrameIOError.Timeout("unable to initialize iframe-io in #{ INITIALIZE_TIMEOUT }ms")

  request: (command, options, timeout) ->
    @_getIO()
    .then (io) ->
      startTime = Date.now()
      io.request(command, options)
      .timeout(timeout)
      .catch Promise.TimeoutError, ->
        if (console?.error)
          console.error("IFrameIO request timed out. Command=#{command}, Plugin=#{options?.context?.plugin}, Elapsed=#{Date.now() - startTime}")
        throw IFrameIOError.Timeout("#{ command } did not complete in #{ timeout }ms")
    .catch PostMessageIO.NotHandled, PostMessageIO.UnsupportedCommand, (err) ->
      throw IFrameIOError.NotHandled("Request to run '#{ command }' failed due to error: '#{ err.message }'")

  drop: ->
    @_iframeEl?.parentNode.removeChild(@_iframeEl)



// WEBPACK FOOTER //
// ./app/scripts/network/iframe-io.coffee